export default __webpack_public_path__ + "4a2ff7798e1f1999fcf29c51e66b945d.png";